import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'info-test-page-two',
  templateUrl: './info-test-page-two.component.html',
  styleUrls: ['./info-test-page-two.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InfoTestPageTwoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
